import { UploadFileWrongFormat } from '@app/core/states/upload.actions';
import { BacsFailure } from '@app/library/states/bacs.actions';
import {
  DeletePlaylistTracksFailure,
  DeletePlaylistTracksSuccess,
  MovePlaylistTracksFailure,
  PlaylistTracksFailure,
} from '@app/library/states/playlist-tracks.actions';
import {
  AddToPlaylistFailure,
  AddToPlaylistSuccess,
  CreatePlaylistDynamicFailure,
  CreatePlaylistDynamicSuccess,
  CreatePlaylistManualFailure,
  CreatePlaylistManualSuccess,
  DeletePlaylistFailure,
  DeletePlaylistSuccess,
  DuplicatePlaylistFailure,
  EditPlaylistDynamicFailure,
  EditPlaylistDynamicSuccess,
  EditPlaylistManualFailure,
  EditPlaylistManualSuccess,
  GetPlaylistFailure,
  InvalidCriteria,
  PlaylistsFailure,
} from '@app/library/states/playlists.actions';
import {
  DeleteTagFailure,
  DeleteTagSuccess,
  EditTagFailure,
  EditTagSuccess,
  RemoveTagsFromMultipleTrackFailure,
  TagsListFailure,
  TagTracksFailure,
} from '@app/library/states/radio-tags.actions';
import {
  CalculateTrackCuesFailure,
  CalculateTrackCuesSuccess,
  TrackCuesFailure,
  UpdateTrackCuesFailure,
  UpdateTrackCuesSuccess,
} from '@app/library/states/track-mix-points.actions';
import {
  TrackArchiveFailure,
  TrackArchiveMultiBacSuccess,
  TrackArchiveSuccess,
  TrackBuyLinkLookupFailure,
  TrackCoverDeleteFailure,
  TrackCoverLookupFailure,
  TrackCoverMultipleSetFailure,
  TrackCoverSingleSetFailure,
  TrackEditFailure,
  TrackEditSuccess,
  TrackMoveFailure,
  TrackMoveSuccess,
  TrackMultipleSetTagsFailure,
  TracksFailure,
  TrackTagsSaveFailure,
  TrackTagsSaveSuccess,
} from '@app/library/states/tracks.actions';
import {
  ArchivedTrackDeleteFailure,
  ArchivedTrackDeleteSuccess,
  ArchivedTrackRestoreFailure,
  ArchivedTrackRestoreSuccess,
  ArchivedTracksFailure,
} from '@app/library/states/trash.actions';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { ToastableItem } from '@radioking/shared/common-services';

export const libraryToasts: ToastableItem[] = [
  {
    action: BacsFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.BAC_LIST_ERROR'),
  },
  {
    action: TracksFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.LIST_ERROR'),
  },
  {
    action: TrackMoveSuccess,
    level: 'success',
    translationKey: marker('TOAST.TRACK.MOVE_SUCCESS'),
  },
  {
    action: TrackMoveFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.MOVE_ERROR'),
  },
  {
    action: TrackArchiveSuccess,
    level: 'success',
    translationKey: marker('TOAST.TRACK.ARCHIVE_SUCCESS'),
  },
  {
    action: TrackArchiveFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.ARCHIVE_ERROR'),
  },
  {
    action: TrackArchiveMultiBacSuccess,
    level: 'success',
    translationKey: marker('TOAST.TRACK.ARCHIVE_SUCCESS'),
  },
  {
    action: ArchivedTracksFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.LIST_ERROR'),
  },
  {
    action: ArchivedTrackRestoreSuccess,
    level: 'success',
    translationKey: marker('TOAST.TRACK.RESTORE_SUCCESS'),
  },
  {
    action: ArchivedTrackRestoreFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.RESTORE_ERROR'),
  },
  {
    action: ArchivedTrackDeleteSuccess,
    level: 'success',
    translationKey: marker('TOAST.TRACK.DELETE_SUCCESS'),
  },
  {
    action: ArchivedTrackDeleteFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.DELETE_ERROR'),
  },
  {
    action: TrackCoverSingleSetFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.COVER_EDIT_SINGLE_ERROR'),
  },
  {
    action: TrackCoverMultipleSetFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.COVER_EDIT_MULTIPLE_ERROR'),
  },
  {
    action: TrackCoverDeleteFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.COVER_DELETE_ERROR'),
  },
  {
    action: TrackCoverLookupFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.COVER_LOOKUP_ERROR'),
  },
  {
    action: TrackBuyLinkLookupFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.BUY_LINK_LOOKUP_ERROR'),
  },
  {
    action: CreatePlaylistManualSuccess,
    level: 'success',
    translationKey: marker('TOAST.PLAYLIST.CREATE_SUCCESS'),
  },
  {
    action: CreatePlaylistManualFailure,
    level: 'error',
    translationKey: marker('TOAST.PLAYLIST.CREATE_ERROR'),
  },
  {
    action: EditPlaylistManualSuccess,
    level: 'success',
    translationKey: marker('TOAST.PLAYLIST.EDIT_SUCCESS'),
  },
  {
    action: EditPlaylistManualFailure,
    level: 'error',
    translationKey: marker('TOAST.PLAYLIST.EDIT_ERROR'),
  },
  {
    action: TrackEditSuccess,
    level: 'success',
    translationKey: marker('TOAST.TRACK.EDIT_SUCCESS'),
  },
  {
    action: TrackEditFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.EDIT_ERROR'),
  },
  {
    action: TrackTagsSaveSuccess,
    level: 'success',
    translationKey: marker('TOAST.TRACK.EDIT_SUCCESS'),
  },
  {
    action: TrackTagsSaveFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.TAG_EDIT_SINGLE_ERROR'),
  },
  {
    action: TrackMultipleSetTagsFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.TAG_EDIT_MULTIPLE_ERROR'),
  },
  {
    action: RemoveTagsFromMultipleTrackFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.TAG_DELETE_ERROR'),
  },
  {
    action: TrackCuesFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.GET_CUES_ERROR'),
  },
  {
    action: UpdateTrackCuesSuccess,
    level: 'success',
    translationKey: marker('TOAST.TRACK.UPDATE_CUES_SUCCESS'),
  },
  {
    action: UpdateTrackCuesFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.UPDATE_CUES_ERROR'),
  },
  {
    action: CalculateTrackCuesSuccess,
    level: 'success',
    translationKey: marker('TOAST.TRACK.UPDATE_CUES_SUCCESS'),
  },
  {
    action: CalculateTrackCuesFailure,
    level: 'error',
    translationKey: marker('TOAST.TRACK.CALCULATE_CUES_ERROR'),
  },
  {
    action: UploadFileWrongFormat,
    level: 'error',
    translationKey: marker('TOAST.TRACK.UPLOAD_NOT_MP3'),
  },
  {
    action: PlaylistsFailure,
    level: 'error',
    translationKey: marker('TOAST.PLAYLIST.FETCH_ERROR'),
  },
  {
    action: PlaylistTracksFailure,
    level: 'error',
    translationKey: marker('TOAST.PLAYLIST.LIST_ERROR'),
  },
  {
    action: CreatePlaylistDynamicSuccess,
    level: 'success',
    translationKey: marker('TOAST.PLAYLIST.CREATE_SUCCESS'),
  },
  {
    action: CreatePlaylistDynamicFailure,
    level: 'error',
    translationKey: marker('TOAST.PLAYLIST.CREATE_ERROR'),
  },
  {
    action: GetPlaylistFailure,
    level: 'error',
    translationKey: marker('TOAST.PLAYLIST.GET_ERROR'),
  },
  {
    action: EditPlaylistDynamicSuccess,
    level: 'success',
    translationKey: marker('TOAST.PLAYLIST.EDIT_SUCCESS'),
  },
  {
    action: EditPlaylistDynamicFailure,
    level: 'error',
    translationKey: marker('TOAST.PLAYLIST.EDIT_ERROR'),
  },
  {
    action: AddToPlaylistSuccess,
    level: 'success',
    translationKey: marker('TOAST.PLAYLIST.ADD_TRACK_SUCCESS'),
  },
  {
    action: AddToPlaylistFailure,
    level: 'error',
    translationKey: marker('TOAST.PLAYLIST.ADD_TRACK_ERROR'),
  },
  {
    action: DeletePlaylistTracksSuccess,
    level: 'success',
    translationKey: marker('TOAST.PLAYLIST.DELETE_TRACK_SUCCESS'),
  },
  {
    action: DeletePlaylistTracksFailure,
    level: 'error',
    translationKey: marker('TOAST.PLAYLIST.DELETE_TRACK_ERROR'),
  },
  {
    action: DeletePlaylistSuccess,
    level: 'success',
    translationKey: marker('TOAST.PLAYLIST.DELETE_SUCCESS'),
  },
  {
    action: DeletePlaylistFailure,
    level: 'error',
    translationKey: marker('TOAST.PLAYLIST.DELETE_ERROR'),
  },
  {
    action: DuplicatePlaylistFailure,
    level: 'error',
    translationKey: marker('TOAST.PLAYLIST.DUPLICATE_ERROR'),
  },
  {
    action: MovePlaylistTracksFailure,
    level: 'error',
    translationKey: marker('TOAST.PLAYLIST.MOVE_ERROR'),
  },
  {
    action: TagsListFailure,
    level: 'error',
    translationKey: marker('TOAST.TAG.FETCH_ERROR'),
  },
  {
    action: TagTracksFailure,
    level: 'error',
    translationKey: marker('TOAST.TAG.LIST_ERROR'),
  },
  {
    action: EditTagSuccess,
    level: 'success',
    translationKey: marker('TOAST.TAG.EDIT_SUCCESS'),
  },
  {
    action: EditTagFailure,
    level: 'error',
    translationKey: marker('TOAST.TAG.EDIT_ERROR'),
  },
  {
    action: DeleteTagSuccess,
    level: 'success',
    translationKey: marker('TOAST.TAG.DELETE_SUCCESS'),
  },
  {
    action: DeleteTagFailure,
    level: 'error',
    translationKey: marker('TOAST.TAG.DELETE_ERROR'),
  },
];

export const librarySideToasts: ToastableItem[] = [
  {
    action: InvalidCriteria,
    level: 'error',
    translationKey: marker('TOAST.SIDE.INVALID_CRITERIA'),
  },
];
